<template>
  <div>
    <h4>{{ inspection ? inspection.name : 'Loading..' }}</h4>

    <div v-if="results && results.length">
      <b-row class="my-4">
        <div class="mx-auto">
          <b-btn variant="primary" @click="go(-1)" :disabled="index == 0">Back</b-btn>
          <b-badge class="mx-3">{{ index + 1 }} of {{ results.length }}</b-badge>
          <b-btn variant="primary" @click="go(1)" :disabled="index == results.length - 1">Next</b-btn>
        </div>
      </b-row>
      <b-row>
        <b-col lg="6">
          <b-row>
            <b-col xl="6">
              <b-form-group label="Raw Request From Publisher"
                            description="Request exactly as received from the publisher">
                <b-textarea class="w-100" style="height: 565px" :value="results[index].rawPubReq"></b-textarea>
              </b-form-group>
            </b-col>
            <b-col xl="6">
              <b-form-group :label="'Request To Bidder ' + results[index].bidderId"
                            description="Request inclusive of bidder specific adaptations">
                <b-textarea class="w-100" style="height: 565px" :value="results[index].reqJson"></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-row class="w-100">
            <b-col>
            <b-form-group label="Raw Bid Response (If Any)"
                          description="Raw bid direct from bidder before processing">
              <b-textarea class="w-100" style="height: 250px" :value="results[index].rawResJson"></b-textarea>
            </b-form-group>
            </b-col>
          </b-row>
          <b-row class="w-100">
            <b-col>
              <b-form-group label="Processed Bid Response"
                            description="Bid post processing as the pub sees it. If missing, it was blocked!">
                <b-textarea class="w-100" style="height: 250px" :value="results[index].processedResJson"></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-alert show v-else>
      No results found. If inspection is active, please refresh to check for new results.
    </b-alert>
  </div>
</template>

<script>
import {AdminApi} from "../api";

export default {
  name: "InspectionResults",
  props: {
    id: { required: true }
  },
  created () {
    this.getInspection()
    this.update()
  },
  methods: {
    go (offset) {
      this.index += offset
    },
    update () {
      AdminApi.inspectionResults(this.id).then((results) => {
        this.results = results;
      }).catch((err) => {
        this.$notify.error('Failed to get results list')
      })
    },
    getInspection () {
      AdminApi.inspection(this.id).then((inspection) => {

        if (!inspection.resCriteria)
          inspection.resCriteria = {};
        this.inspection = inspection;
      }).catch((err) => {
        this.$notify.error("Failed to load inspection details")
      })
    }
  },
  data () {
    return {
      inspection: null,
      results: null,
      index: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/pages/InspectionResults.vue